/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Function} callback The function to debounce.
 * @param {Number} wait - The amount of time before debounce call is triggered.
 * @param {Boolean} immediate - Trigger the immediately.
 */
export function debounce(callback, wait, immediate) {
  let timeout = null

  // eslint-disable-next-line func-names
  return function(...args) {
    const later = function() {
      timeout = null
      if (!immediate) {
        callback.apply(this, args)
      }
    }

    const callNow = immediate && !timeout
    window.clearTimeout(timeout)
    timeout = window.setTimeout(later, wait)

    if (callNow) {
      callback.apply(this, args)
    }
  }
}

/**
 * Shortcut function to add an event listener.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com.
 * @param {String} event -The event type.
 * @param {Node} element - The element to attach the event to (optional,
 * defaults to window).
 * @param {Function} callback - The callback to run on the event.
 * @param {Boolean} capture - If true, forces bubbling on non-bubbling events.
 */
export function on(event, element = window, callback, capture = false) {

  /**
   * If only a string is passed into the element parameter.
   */
  if (typeof elem === 'string') {
    document.querySelector(element).addEventListener(event, callback, capture)
    return
  }

  /**
   * If an element is not defined in parameters, then shift callback across.
   */
  if (typeof element === 'function') {
    window.addEventListener(event, element)
    return
  }

  /**
   * Default listener.
   */
  element.addEventListener(event, callback, capture)
}
